import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { startAlerta } from "../../../../actions/ui/alertas";
import { ValidatorForm } from "react-material-ui-form-validator";
import { postSolicitudDiscapacidadAutoG, updateSolicitudDiscapacidadAutoGValues } from "../../../../actions/webAfiliado/afiliadoDiscapacidadActions";
import { STEPPER_INTEGRACION_AUTO_G, TIPO_SOLICITUD_INTEGRACION } from "../../../Discapacidad/data/constants";
import { IntegracionAccordionDiagnostico } from "../../../Discapacidad/Home/ingreso/IntegracionAccordionDiagnostico";
import { IntegracionAccordionDocumentacion } from "../../../Discapacidad/Home/ingreso/IntegracionAccordionDocumentacion";
import { getFormularioCud } from "../../../../actions/discapacidad/discapacidadActions";

export const NuevaSolicStep4 = (props) => {
  const dispatch = useDispatch();

  const [datosCompletosDiagnostico, setDatosCompletosDiagnostico] =
    useState(false);
  const [datosCompletosDocumentacion, setDatosCompletosDocumentacion] = useState(false);

  const { solicitudSeleccionada} = useSelector(
    (state) => state.afiliadoDiscapacidad
  );
  const { formularioCud } = useSelector(
    (state) => state.discapacidad
  );

  const [redirect, setRedirect] = useState(false);

  useEffect(()=>{
    dispatch(getFormularioCud(solicitudSeleccionada.idAfiliado,true));
  },[])

  useEffect(()=>{
    dispatch(
      updateSolicitudDiscapacidadAutoGValues({
        diagnostico: formularioCud?.diagnosticos[0]?.descripcion,
        codCie10: formularioCud?.diagnosticos[0]?.codCie10,
      })
    );
  },[])
  const submitHandler = (e) => {
    e.preventDefault(); 
    if (datosCompletosDocumentacion && formularioCud?.diagnosticos?.length > 0) {
      dispatch(postSolicitudDiscapacidadAutoG(
          {...solicitudSeleccionada}, 
          null,
          setRedirect,
          true,
        )
      );
    } else {
      dispatch(
        startAlerta(
          `Debe completar la documentación. ${formularioCud?.diagnosticos?.length === 0 ? "Debe agregar un diagnostico en la carga de CUD.":""}`,
          "error"
        )
      );
    }
  };
  return (
    <ValidatorForm onSubmit={submitHandler}>
      <IntegracionAccordionDiagnostico
        autogestion={true}
        datosCompletos={datosCompletosDiagnostico}
        setDatosCompletos={setDatosCompletosDiagnostico}
      />
       <IntegracionAccordionDocumentacion
       autogestion={true}
        datosCompletos={datosCompletosDocumentacion}
        setDatosCompletos={setDatosCompletosDocumentacion}
      /> 
      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{ marginRight: "3rem" }}
          onClick={() => {
            props.handleChangeStep(
              (solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.ESCUELAS || 
                solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.HOGAR)
              ? STEPPER_INTEGRACION_AUTO_G.DETALLES_ORDEN
              : STEPPER_INTEGRACION_AUTO_G.COMPLEMENTO_ORDEN
            )
          }}
        >
          Anterior
        </Button>
        <Button variant="contained" color="primary" type="submit">
          Siguiente
        </Button>
        {redirect && (
          <Redirect
            to={{
              pathname: "/afiliado/discapacidad",
            }}
          />
        )}
      </div>
    </ValidatorForm>
  );
};
